/**
 * organization config (doc 01 A6 Organization, doc 13 T13). `GET /organization`
 * and `PUT /organization`, both gated `org:manage`. The detail response also
 * carries the org's site list (tenancy `location` rows) so the settings screen
 * renders identity, operational config, and sites from one request.
 *
 * No secrets here: address/phone/website/primaryContact are org-facing facts,
 * never credentials (ADR 0013 — write-only secrets live elsewhere).
 */
import { get, put } from './transport.js';
/**
 * OPERATING JURISDICTIONS — reachable as `organization.jurisdictions.*`.
 *
 * They are organization configuration, but they are NOT `org:manage`: the key
 * is `jurisdiction:configure`, because which state's law binds this agency is
 * not the same authority as its phone number. See `./jurisdictions.ts`.
 *
 * Re-exported through this module rather than added to `index.ts`, which is
 * integrator-owned. Promoting it to a top-level namespace is one line there,
 * and nothing in either file changes when that happens.
 */
export * as jurisdictions from './jurisdictions.js';
/** `GET /organization` → `{ organization, sites }` (needs `org:manage`). */
export async function detail(options) {
    return get('/organization', options);
}
/** `PUT /organization` → `{ organization }` (needs `org:manage`). */
export async function update(patch, options) {
    const body = await put('/organization', patch, options);
    return body.organization;
}
//# sourceMappingURL=organization.js.map